export const iconFontAwesomeMapsBell = (
	<i className="fa-solid fa-bell"></i>
);
